/**
 *
 * Asynchronously loads the component for Invite Users
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
